module.exports = __webpack_public_path__ + "static/media/frog.b7465c50.svg";